<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n">設定</h2>
    <div class="hpanel">
      <nav-tabs :tab="tab" :disabled="disabledTab"></nav-tabs>
      <tab-content :tab="tab" @checkData="checkData"></tab-content>
    </div>
  </div>
</template>
<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      disabledTab: false,
      loader: null
    }
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['user-info', 'login-info', 'plan-info', 'service-info', 'payment-info', 'payment-cycle', 'agent-notice', 'others'].includes(toTab)) {
        this.tab = toTab
      }
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (['user-info', 'login-info', 'plan-info', 'service-info', 'payment-info', 'payment-cycle', 'agent-notice', 'others'].includes(this.tab)) {
      this.loader = this.$loading.show()
    } else {
      this.$router.push('/not-found')
    }
  },
  methods: {
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    checkData (hasData) {
      this.disabledTab = !hasData
      if (hasData && this.$route.params.tab) {
        this.tab = this.$route.params.tab
      } else {
        this.$router.push('/setting')
      }
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/Setting.vue